import React from 'react';
import { ErrorMessage, MessageWrapper } from '@atlaskit/form';
import { fg } from '@atlaskit/platform-feature-flags';
import { ErrorWrapper } from './questionWrappers';
export var QuestionErrorMsg = function QuestionErrorMsg(_ref) {
  var errorId = _ref.errorId,
    validationErrors = _ref.validationErrors;
  return /*#__PURE__*/React.createElement(ErrorWrapper, null, /*#__PURE__*/React.createElement(MessageWrapper, null, validationErrors && /*#__PURE__*/React.createElement(ErrorMessage, null, /*#__PURE__*/React.createElement("span", {
    id: fg('jsm-accessibility-fixes') ? errorId : undefined
  }, validationErrors.map(function (validationError) {
    return /*#__PURE__*/React.createElement("span", {
      key: validationError.key
    }, validationError.message, "\xA0");
  }), "\xA0"))));
};